import React from "react";
import { useTranslation } from "react-i18next";
import ModalAtom from "../../../../../components/atoms/modal/modal";

function DeleteConfirmationModal({ show, onClose, onConfirm, title, message }) {
	const { t } = useTranslation();

	return (
		<ModalAtom
			title={title || t("aufmass.delete-line")}
			body={<p>{message || t("aufmass.delete-line-warning")}</p>}
			saveText={t("delete")}
			show={show}
			handleClose={onClose}
			handleSubmit={onConfirm}
		/>
	);
}

export default DeleteConfirmationModal;
